import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { LineChart, Line, XAxis, YAxis, Label, CartesianGrid, Legend } from 'recharts';

import { RechartsDevtools } from '@recharts/devtools';


import Histogram from './Hist'


import styles from '../styles/TestOverview.module.css';
import {
  FindTestToUpdate,
  UpDateWordRecall,
  AddNotes, 
  closeForm
 } from "./UpdateTestFunctions.js"

 import "./TestFunction.js"

/* 
<h3>Replay Drawing</h3>
            <div style={{position: 'relative'}}>
              <img id="ReplayImage" src={value} alt="Sketchpad screenshot"></img>
               showPosition('ReplayImage')  
            </div>
            <div style={{position: 'absolute', top: '100'}}>JASXXON</div>
*/

// https://www.robinwieruch.de/react-button/

function addSpaceBetweenListItems(p1) {
  //return " "+Math.round(p1*1000)/1000;
  return " "+p1;
}
// Open the form for editing the word recall table


// NEED TO READ THIS (6/14/24) https://www.quirksmode.org/js/findpos.html
//<div style={{position: 'absolute', left: findPos(document.getElementById('ReplayImage'))[0],  top: findPos(document.getElementById('ReplayImage'))[1]}}>X</div>

/*          <h3>Replay Drawing</h3>
            <div style={{position: 'relative'}}>
              <img id="ReplayImage" src={value} alt="Sketchpad screenshot"></img>
            </div>
*/


function showPosition(id) {
  var element = document.getElementById(id)
  const rect = element.getBoundingClientRect();
  console.log("X: " + rect.x, "Y: "+(rect.y+window.scrollY))
  
}
function findPos(obj) {
  var curleft = 0;
  var curtop = 0;
  if ( obj.offsetParent ) {
    do {
        curleft += obj.offsetLeft;
        curtop += obj.offsetTop;
    }
    while ( obj = obj.offsetParent );
    }
  return [curleft, curtop]
}
function AddMouseTracking() {
  console.log("MOUSE TRACK BUTTON PRESSED")
  console.log(findPos(document.getElementById('ReplayImage')))
  return <div style={{position: 'absolute', left: findPos(document.getElementById('ReplayImage'))[0],  top: findPos(document.getElementById('ReplayImage'))[1]}}>X</div>
  //return null
}

function showPositionY(id) {
  var element = document.getElementById(id)
  const rect = element.getBoundingClientRect();
   return (rect.y+window.scrollY)
}

function showParameters(testData) {
  console.log(testData)
    // Get the modal
  var modal = document.getElementById("parametersModal");
  var parameterInfo = document.getElementById("parameterInformation");
  // FETCH PARAMETERS FROM dB and UPDATE here
  console.log(testData)
  const component = testData.history.find(o => o.id === testData.alle)
  console.log(component)
  const ID = component.id
  console.log(ID)
  // update the word recall table in JATOS 
  fetch(`/fetch_Parameters/${component.id}`)
    .then((response) => { 
      return response.json() 
    }).then((data) => {
      var TableOfParameters = `<table border = 1>`
      TableOfParameters += `<tr><td><b>Parameter</b></td><td><b>Value</b></td></tr>`
      console.log(data[0].d['NBlocks'])
      console.log(Object.keys(data[0].d).forEach(function (key) 
      {
        TableOfParameters += `<tr><td>`
        TableOfParameters += key
        TableOfParameters += `</td><td>`
        TableOfParameters += data[0].d[key]
        TableOfParameters += `</td></tr>`
      }
      //TableOfParameters += `</table>`
      ))
      parameterInfo.innerHTML = JSON.stringify(data[0].d)
      parameterInfo.innerHTML = TableOfParameters
    })
  
  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close")[0];
    modal.style.display = "block";
    // When the user clicks on <span> (x), close the modal
    span.onclick = function() {
      modal.style.display = "none";
    }

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }
}

function MakeData(input) {
    let output = []
    for ( var i = 0; i < input.input.length; i++ )
    {
      output.push({x: i+1, y: input.input[i]})
    }
    return output
  }

  function DisplayTextOrGraph({inputData}) {
    let input = inputData.data
    let key = inputData.key
    let message
    console.log(inputData)
    console.log("KEY: "+key)
    console.log("INPUT: "+input)
    if ( Array.isArray(input) && input.length > 1 && input.every(value => typeof value === 'number' && !isNaN(value)) )
      {
        var ddd = MakeData({input})
        message = 
            <LineChart
                style={{ width: '100%', 
                  maxWidth: '800px', 
                  height: '100%', 
                  maxHeight: '60vh', 
                  aspectRatio: 1.618,
                  backgroundColor: "white" }}
                responsive
                data={ddd}
                margin={{
                  top: 5,
                  right: 10,
                  left: 35,
                  bottom: 25,
                }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="x" >
                {/* X-Axis Label */}
                <Label value="Trial Number" offset={-10} position="insideBottom" />
              </XAxis>
              <YAxis width="auto">
              <Label value={key} angle={-90} 
                  position="insideLeft" 
                  offset={-5}
                  style={{ textAnchor: 'middle' }} />
              </YAxis>
              <Line dataKey="y" stroke="#000b05" strokeWidth={3}/>
              <RechartsDevtools />
            </LineChart>
      }
    else { 
      // Check the numbers and format them appropriately
      if ( typeof input === 'number' )
      
        {
        var output = Number(input)
        if ( !Number.isInteger(output) )
        { output = output.toFixed(4)}
      }
      else if ( Array.isArray(input) )
        { var output = input.join(', ') }
      else { var output = input }
      message = <div><b>{key}:</b> <b>{output}</b> </div>
    }
    return <div>{message}</div>
  }    
// make function to add the edited information back to the displayed original table


function renderSwitch(key, value, data) {
 if ( value == null ) { value = ['NULL'] }
 const _foo = value[0];
 // {console.log(data)}
 <div>return ({key})</div>
  //https://stackoverflow.com/questions/46592833/how-to-use-switch-statement-inside-a-react-component
  switch(key) {
    case 'Point by Point Data':
      console.log("### POINT #### POINT ####")
      return (
        <div>
        <p></p>
          <div><h3>POINT BY POINT DATA</h3></div>
          <div>
          <table border='1px'>
            <thead>
              <td><b>Count</b></td>
              <td><b>Label</b></td>
              <td><b>Distance (pix)</b></td>
              <td><b>Speed (pix/ms)</b></td>
              <td><b>Dwell Time (ms)</b></td>
              <td><b>Errors</b></td>
            </thead>
            <tbody>
            {value.map((item,index) => {
                return (
                  <tr>
                    <td align="right">{item.Count}</td>
                    <td align="right">{item.Label}</td>
                    <td align="right">{item.Distance ? item.Distance.toFixed(2) : '-99'}</td>
                    <td align="right">{item.speed ? item.speed.toFixed(2): '-99'}</td>
                    <td align="right">{item.DwellTime ? item.DwellTime.toFixed(2) : '-99'}</td>
                    <td align="right">{item.Error}</td>
                  </tr>
                )
                })}
            </tbody>
          </table>
        </div>
          
        </div>
      )
    case 'MouseTracking':
      return (
        <div>Found mouse tracking data
         
        </div>
        )
    case 'SummaryImage': 
        return (<div> 
        <h3>Final Drawing</h3>
          <img src={value} alt="Sketchpad screenshot"></img>
        </div>)
    case 'Image':
      console.log({value})  
      // Is this an array of images?
      if ( Array.isArray(value) ) {
        console.log("FOUND AN ARRAY OF IMAGES")
        return (
          <div> 
          <h3>Final Drawing</h3>
            {value.map((i,ind) => {return (
              <div>
                <h4>Block {ind+1}</h4>
                <img src={i} className={styles.replayImage} alt="Sketchpad screenshot"></img>
              </div>)})}
          </div>
        )
      }
      else {
      return (

          <div>
          <h3>Final Drawing</h3>
            <img src={value} style={{ width: '50vw' }} alt="Sketchpad screenshot"></img>
          </div>
        )}
    case 'GIF':
      console.log({value})
      // Is this an array of images?
      if ( Array.isArray(value) ) {
        console.log("FOUND AN ARRAY OF IMAGES")
        return (
          <div>
          <h3>Final Drawing</h3>
            {value.map((i,ind) => {return (
              <div>
                <h4>Block {ind+1}</h4>
                <img src={i} style={{ width: '40vw' }} alt="Sketchpad screenshot"></img>
              </div>)})}
          </div>
        )
      }
      else {
      return (

          <div>
          <h3>Final Drawing</h3>
            <img src={value} className={styles.replayImage} alt="Sketchpad screenshot"></img>

          </div>
        )}
    case 'history':
        
        return (
          <div>JASON</div>
        )

    case 'Audio':
        console.log("FOUND AUDIO")
        return (
          <div> 
          <h3>Audio recording</h3>
            <div>
            {value.map((i,ind) => {return (
              <div>
                <h4>Block {ind+1}</h4>
                <audio controls="controls" autobuffer="autobuffer">
                  <source src={"data:audio/mpeg;base64,"+value[ind]}/>
                </audio>
              </div>)})}   
            </div>
          </div>
        )
        
    case 'DS Response Array':
      return ( 
        <div>
          <table border='1px'>
            <thead>
              <td>Trial</td>
              <td>Load</td>
              <td>List</td>
              <td>Response</td>
              <td>Accuracy</td>
            </thead>
            <tbody>
            {value.map((item,index) => {
                return (
                  <tr>
                    {item.map((i,ind) => {return (<td>{Array.isArray(i) ? addSpaceBetweenListItems(i) : i}</td>)})}  
                  </tr>
                )
                })}
            </tbody>
          </table>
        </div>
        )

    case 'Response Array A':
      return (
        <div>
          <h3>Word List</h3>
          <table id="WordListResponseTable">
          <thead>
            <td>Word</td>
              {_foo.map((i,ind) => {return (<td>Block {ind+1}</td>)})}   
          </thead>
          <tbody >
              {value.map((item,index) => {
                return (
                  <tr>
                    <td>{data.WordListA[index]}</td>
                    {item.map((i,ind) => {
                      // show a saved M (miss) or homonym word in place of the number
                      const note = data["Response Array A Notes"]?.[index]?.[ind]
                      return (<td>{note ? note : (i < 0 ? ' ' : i+1)}</td>)
                    })}
                  </tr>
                )
                })}
            </tbody>
            
          </table>
        </div>
      )
    case 'Response Array B':
      return (
        <div>
          <h3>Word List B</h3>
          <table>
          <thead>
            <td>Word</td>
              {_foo.map((i,ind) => {return (<td>Block {ind+1}</td>)})}   
          </thead>
          <tbody >
              {value.map((item,index) => {
                return (
                  <tr>
                    <td>{data.WordListB[index]}</td>
                    {item.map((i,ind) => {return (<td>{i < 0 ? ' ' : i}</td>)})}  
                  </tr>
                )
                })}
            </tbody>
            
          </table>
        </div>
      )
    case 'Intrusions A':
      return (
        <div>
        <h3>Intrusions During A</h3>
          <table border='1px'>
            <tbody>
              {value.map((item,index) => {
                return (
                  <tr>
                    <td>Block {index+1}</td>
                    <td>{addSpaceBetweenListItems(item)}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )
    case 'Intrusions B':
        return (
          <div>
          <h3>Intrusions During B</h3>
            <table border='1px'>
              <tbody>
                {value.map((item,index) => {
                  return (
                    <tr>
                      <td>Block {index+1}</td>
                      <td>{addSpaceBetweenListItems(item)}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        )  

    case 'User Said A':
          return (
            <div>
            <h3>Speech Processing A</h3>
              <table border='1px'>
                <thead>
                  <tr>
                    <td>Block</td>
                    <td>Edited</td>
                    {/* <td>Original</td> */}
                  </tr>
                </thead>
                <tbody>
                  {value.map((item,index) => {
                    // split into chunks by semicolons, then keep only the text
                    // before the first comma in each chunk
                    const firstParts = String(item ?? '')
                      .split(';')
                      .map((chunk) => chunk.split(',')[0].trim())
                      .filter((part) => part !== '')
                    // original text column, commented out; uncomment both Original lines to show it again
                    return (
                      <tr>
                        <td>Blk {index+1}</td>
                        <td>{firstParts.join('; ')}</td>
                        {/* <td style={{ color: 'grey' }}>{item}</td> */}
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          )
    case 'User Said B':
      return (
        <div>
        <h3>Speech Processing B</h3>
          <table border='1px'>
            <tbody>
              {value.map((item,index) => {
                return (
                  <tr>
                    <td>Blk {index+1}</td>
                    <td>{item}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )  
    case 'Speech Processing':
      return (
      <div><h4>Speech Processing:</h4>
      <p>[Note: The speech processing program makes of list of what it thinks it hears and chooses the most probable words. 
      The most probale words are shown in <em>Spoken Words.</em> The five other possible words are listed in <em>Speech Processing</em>]
      </p>
        {value.split(';').map(line => <li key="{line}">{line}</li>)}
      </div>)
    case 'Spoken Words':
      return (        
      <div><h4>Spoken Words:</h4>
        <div>{value.map((i, ind) => {return (i+', ' )})}</div>
      </div>)
   
    case 'WordListA':
      return (<div></div>)
    case 'Response Array A Notes':
      // shown inside the Word List table
      return (<div></div>)
    case 'WordListB':
      return (<div></div>)
    case 'ScoreName':
      return (<div></div>)
    case 'Accuracy':
      return (<div></div>)
    case 'CardSortColNames':
        return (<div></div>)
    case 'Card Sort Table':
      return (
      <div>
          <h3>Card Sort</h3>
          <table border='1px'>
          <thead>
            {data.CardSortColNames.map((item, index) => { return <td>{item}</td>})}
          </thead>
          <tbody >
              {value.map((item,index) => {
                return (
                  <tr>
                    
                    {item.map((i,ind) => {return (<td>{i}</td>)})}  
                  </tr>
                )
                })}
            </tbody>
            
          </table>
          {data.TableColNames}
        </div>
      
      
      
      )

    default:
      console.log("DEFAULT CASE")
      var objToPass = {}
      objToPass.key = key
      objToPass.data = value

     return (
            <div>
              <DisplayTextOrGraph inputData = {objToPass}/>
            </div> 
          )

  }
}

// Export the Word List table, as currently shown on the page, to
// {BatchName}_{WorkerID}_WordRecall.csv, followed by some session information
async function exportWordListCSV(testData, username) {
  const table = document.getElementById("WordListResponseTable")
  if ( !table ) {
    alert("There is no Word List table to export")
    return
  }
  // quote every cell and escape any quotes inside it
  const toCSVRow = (cells) => cells.map((c) => '"' + c.textContent.trim().replace(/"/g, '""') + '"').join(",")
  const lines = [toCSVRow([...table.querySelectorAll("thead td")])]
  table.querySelectorAll("tbody tr").forEach((row) => {
    lines.push(toCSVRow([...row.cells]))
  })

  // two empty rows, then one label/value row per piece of information
  const quote = (v) => '"' + String(v ?? '').replace(/"/g, '""') + '"'
  const exportTime = new Date().toLocaleString("en-CA", { dateStyle: "medium", timeStyle: "short" })
  lines.push("", "")
  lines.push(quote("Start Time") + "," + quote(testData?.startDate))
  lines.push(quote("Export Time") + "," + quote(exportTime))
  lines.push(quote("Exported By") + "," + quote(username))
  lines.push(quote("Worker ID") + "," + quote(testData?.workerID))

  // notes added with the Add Notes button; fetched so ones added this visit are included
  var notes = testData?.Data?.Notes
  try {
    const response = await fetch(`/fetch_Notes/${testData.alle}`)
    const data = await response.json()
    if ( data.length ) { notes = data[0].d }
  } catch (error) {
    console.error(error)
  }
  // always include the Notes label, with an empty value if there are no notes
  lines.push(quote("Notes") + "," + quote(notes))

  var BatchName = document.getElementById('SelectedBatch')?.textContent
  if ( !BatchName ) { BatchName = "Default" }

  // Create a Blob with the CSV data and download it
  const blob = new Blob([lines.join("\n") + "\n"], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = BatchName + "_" + testData?.workerID + "_WordRecall.csv";
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

const TestInstance = ({ testData, username }) => {


  const navigate = useNavigate();
  const UpdateWordRecall = (input) => {alert("Notice: "+ input)};

  // The overview only loads the summary results, so fetch the audio, images,
  // GIFs and mouse tracking for this result here
  const [media, setMedia] = useState({});
  useEffect(() => {
    setMedia({});
    if (!testData?.resultDataId) return;
    fetch(`/get_component_result_data/${testData.resultDataId}`)
      .then((response) => response.json())
      .then((rows) => {
        if (!rows.length || !rows[0].data) return;
        // some JSON data has line breaks in it which need to be removed
        const fullData = JSON.parse(rows[0].data.replace(/(\r\n|\n|\r)/gm, ""));
        if (!Array.isArray(fullData)) return;
        const found = {};
        fullData.forEach((trial) => {
          if (trial.hasOwnProperty("AudioResponse")) {
            (found.Audio = found.Audio || []).push(trial.AudioResponse);
          }
          if (trial.hasOwnProperty("png")) {
            (found.Image = found.Image || []).push(trial.png);
          }
          if (trial.hasOwnProperty("gif")) {
            (found.GIF = found.GIF || []).push(trial.gif);
          }
          if (trial.hasOwnProperty("mouse_tracking_data")) {
            found.MouseTracking = trial.mouse_tracking_data;
          }
        });
        setMedia(found);
      })
      .catch((error) => console.error(error));
  }, [testData?.resultDataId]);
  const displayData = { ...testData.Data, ...media };

  
  return (
    
    <div className={styles.container}>
    <div id="parametersModal" class="modal">
      <div class="modal-content">
        <span class="close">&times;</span>
        <div id="parameterInformation">No available parameters</div>
      </div>

    </div>


      <div className={styles.reviewContainer}>
        <div>
          <button
            type="button"
            style={{ backgroundColor: "white" }}
            onClick={() => navigate(testData?.fromPath || "/profile")}
          >
            &larr; Back to Test Overview
          </button>
        </div>
        <div className={styles.header}>{testData?.title} Review for Participant: {testData?.workerID}</div>
        <div className={styles.review}>
        
          <div><b>Start Time: </b> {testData.startDate}</div>
          <div><b>End Time: </b> {testData.endDate}</div>
          {
            
            Object.entries(displayData).map(([key, value]) => (
            <div>
              {renderSwitch(key, value, displayData)}
            </div>
          ))}
        </div>
        
        <div>
            
          <button type="button" onClick={() => FindTestToUpdate(testData)}>Update Score</button>
          <button type="button" onClick={() => AddNotes(testData)}>Add Notes</button>
          <button type="button" class="btn" onClick={() => showParameters(testData)}>Show Parameters</button>
          
        </div>
        
        
        <div class="chat-popup" id="myForm">
          <form class="form-container">
            <div id="PopupContent">
            </div>
            <button type="button" id="SubmitButton" class="btn">Submit</button>

            <button type="button" class="btn cancel" onClick={closeForm}>Close</button>
          </form>
        </div>

        <div>
          <button
            type="button"
            style={{ backgroundColor: "white" }}
            onClick={() => navigate(testData?.fromPath || "/profile")}
          >
            &larr; Back to Test Overview
          </button>
          {testData?.Data?.["Response Array A"] && (
            <button type="button" onClick={() => exportWordListCSV(testData, username)}>Export</button>
          )}
        </div>
      </div>
    </div>


  );
}
//<div><button type="button" onClick={JasonClick02(JSON.stringify(testData.componentResultsId))}>Update Score</button></div>



export default TestInstance;